<app-base-page-template>
  <app-base-page-content-template>
    <app-messages-grid
      #messagesGrid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-messages-grid>
  </app-base-page-content-template>
</app-base-page-template>
